import { useEffect, useRef, useState } from "react";
import {
  deteleStudentRegistration,
  reRegistrationStudent,
} from "../../api/etudiants";
import { Link, useParams } from "react-router";
import { toast } from "sonner";
import {
  getStudentArchivesById,
  updateStudentRegistration,
} from "../../api/archives";
import { getAllAcademicYear } from "../../api/generalParam";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getAllClass } from "../../api/pedagogicElement";
import CommonSelect from "../../core/common/commonSelect";
import { Select } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { z } from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import CreateExternalNoteModal from "./externalNotes/createExternalNoteModal";
import EditExternalNoteModal from "./externalNotes/editExternalNoteModal";
import ExternalModalApercu from "./externalNotes/externalModalApercu";
import EditParcoursModal from "./EditParcoursModal";

import {
  deleteExternalNote,
  getExternalNoteByStudent,
} from "../../api/externalNote";

import { AxiosError } from "axios";
import { deleteStudentParcours, getStudentParcours } from "../../api/settings";
import ReregistrationWihtNewParcours from "./reRegistrationWithNewParcour";

const getMention = (note: number): string => {
  const roundedNote = Math.round(note * 100) / 100; // Arrondi à 2 décimales
  if (roundedNote >= 0 && roundedNote < 10) return "Contrôle";
  if (roundedNote >= 10 && roundedNote < 12) return "Passable";
  if (roundedNote >= 12 && roundedNote < 14) return "Assez Bien";
  if (roundedNote >= 14 && roundedNote < 16) return "Bien";
  if (roundedNote >= 16 && roundedNote < 18) return "Très Bien";
  if (roundedNote >= 18 && roundedNote <= 20) return "Excellent";
  return "Non noté";
};

// Shéma pour le formulaire de re-inscription
const re_registrationShema = z.object({
  promotionYear: z
    .object(
      {
        value: z.string(),
        label: z.string(),
        statut: z.boolean(),
      },
      {
        required_error: "Veuillez choisir une année valide",
        invalid_type_error: "Veuillez choisir une année valide",
      },
    )
    .nullable()
    .refine(
      (val) => val && val.value && val.label,
      "veuillez choisir une année valide",
    ),

  promotionClass: z
    .object(
      {
        value: z.string(),
        label: z.string(),
      },
      {
        required_error: "Veuillez choisir une classe valide",
        invalid_type_error: "Veuillez choisir une classe valide",
      },
    )
    .nullable()
    .refine(
      (val) => val && val.value && val.label,
      "veuillez choisir une classe valide",
    ),
});

type reRegistrationFormFields = z.infer<typeof re_registrationShema>;

const editRegistrationShema = z.object({
  classe: z
    .object(
      {
        value: z.string(),
        label: z.string(),
      },
      {
        required_error: "Veuillez choisir une classe valide",
        invalid_type_error: "Veuillez choisir une classe valide",
      },
    )
    .nullable()
    .refine(
      (val) => val && val.value && val.label,
      "veuillez choisir une classe valide",
    ),
  statut: z.boolean(),
});

type editRegistrationFormFields = z.infer<typeof editRegistrationShema>;

//  bouton protégée pour une ré-inscription
const ProtectedUpdateStudent = withPermission(
  (props: any) => (
    <button
      //   to="#"
      className="dropdown-item"
      //   data-bs-toggle="modal"
      //   data-bs-target="#connect_app"
      onClick={() => {
        props.setShow(true);
        props.setSelectedParcours(props.id_parcourStudent);
      }}
    >
      <i className="ti ti-refresh" /> Re-Inscrire
    </button>
  ),
  [buildPermission(Resource.STUDENT, Action.CREATE)],
  "masquer",
);

// bouton proteger pour supprimer une inscription
const ProtectedBtnDeleteRegistration = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() =>
          props.showConfirmationAlertRegistration(props.record, true)
        }
      >
        <i className="ti ti-trash me-2" />
        Supprimer l'inscription
      </Link>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.DELETE)],
  "masquer",
);

const ProtectedBtnEditRegistration = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => props.openEditRegistration(props.record)}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier l'inscription
      </Link>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const ProtectedBtnEditParcoursOfRegistration = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => {
          props.setCurrentArchiveToEdit(props.record);
          props.setShowEditParcoursModal(true);
        }}
      >
        <i className="ti ti-vector me-2" />
        Modifier le parcours de l'inscription
      </Link>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);
// bouton pour ajouter une inscription avec un nouveau parcours
const ProtectedBtnAddReregistrationWithParcours = withPermission(
  (props: any) => (
    <button
      //   to="#"
      className="btn btn-warning mt-4"
      //   data-bs-toggle="modal"
      //   data-bs-target="#connect_app"
      onClick={() => {
        props.setShowReregistrationWithParcours(true);
      }}
    >
      <i className="ti ti-plus" />
      Ajouter un parcours
    </button>
  ),
  [buildPermission(Resource.STUDENT, Action.CREATE)],
  "masquer",
);

// bouton pour supprimer un parcours
const ProtectedButtonDeleteParcours = withPermission(
  (props: any) => (
    <button
      //   to="#"
      className="dropdown-item"
      onClick={() => {
        props.showConfirmationAlertParcours(props.id_parcourStudent);
      }}
    >
      <i className="ti ti-trash" />
      Supprimer le Parcours
    </button>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

// bouton protégé pour la création d'une note externe
const ProtectedAddExternalNote = withPermission(
  (props: any) => (
    <button
      className="dropdown-item"
      onClick={() => {
        // console.log("cliquer sur le btn");
        props.setShow(true);
        props.setSelectedParcours(props.id_parcourStudent);
      }}
    >
      <i className="fa fa-suitcase p-20" /> Ajouter Note Externe
    </button>
  ),
  [buildPermission(Resource.EXTERNAL_NOTE, Action.CREATE)],
  "masquer",
);

// bouton protégée pour modifier une note externe
const ProtectedBtnUpdateExternalNote = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => {
          props.setSelectedParcours(props.id_parcourStudent);
          props.setEditNote(props.record.id);
          props.setShowEdit(true);
        }}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </Link>
    </li>
  ),
  [buildPermission(Resource.EXTERNAL_NOTE, Action.UPDATE)],
  "masquer",
);

// bouton protégée pour supprimer une note externe
const ProtectedBtnDeleteExternalNote = withPermission(
  (props: any) => (
    <li>
      <Link
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
        to="#"
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </Link>
    </li>
  ),
  [buildPermission(Resource.EXTERNAL_NOTE, Action.DELETE)],
  "masquer",
);

const ProtectedPreuveExternalNote = withPermission(
  (props: any) => (
    <>
      <div className="flex-grow-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Pièce Justificatif</Tooltip>}
        >
          <Link
            type="button"
            to="#"
            className="dropdown-item rounded-1"
            onClick={() => {
              props.setExternalID(props.externalNoteItem?.id);
              props.setShowModal(true);
            }}
          >
            <i className="ti ti-paperclip" /> Pièce Jointe
          </Link>
        </OverlayTrigger>
      </div>
    </>
  ),
  [
    buildPermission(Resource.EXTERNAL_NOTE, Action.READ),
    buildPermission(Resource.EXTERNAL_NOTE, Action.UPDATE),
    buildPermission(Resource.EXTERNAL_NOTE, Action.DELETE),
    buildPermission(Resource.EXTERNAL_NOTE, Action.CREATE),
  ],
  "masquer",
);

const ProtectedBtnDeactivateArchive = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => props.showConfirmationAlertArchive(props.record, false)}
      >
        <i className="ti ti-user-off me-2" />
        Désactiver l'inscription
      </Link>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const ProtectedBtnActivateArchive = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => props.showConfirmationAlertArchive(props.record, true)}
      >
        <i className="ti ti-user-check me-2" />
        Activer l'inscription
      </Link>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const StudentArchive = () => {
  const { id } = useParams(); // On récupère l'id de l'URL

  // Modal détails
  const [show, setShow] = useState(false);
  const [showReregistrationWithParcours, setShowReregistrationWithParcours] =
    useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [showEditParcoursModal, setShowEditParcoursModal] = useState(false);

  // id de la note à modifier
  const [editNote, setEditNote] = useState("");

  // State pour le PDF et le modal releve de note
  const [showModal, setShowModal] = useState(false);
  const [externalID, setExternalID] = useState("");

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  //Traitement en alert de la demande de suppression d'une note externe
  const showConfirmationAlert = (externalNote: any) => {
    MySwal.fire({
      title: "Supprimer une note externe ?",
      text: `Souhaitez-vous vraiment supprimer cette note externe ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await deleteExternalNote(externalNote?.id);
          MySwal.fire({
            title: "Note externe supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          fetchStudentExternalNotes();
          // reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.message ||
              err.response?.data?.message ||
              err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //Traitement en alert de la demande desactivation d'une inscription
  const showConfirmationAlertArchive = (archiveItem: any, statut: boolean) => {
    MySwal.fire({
      title: statut ? "Activer l'inscription ?" : "Désactiver l'inscription ?",
      text: `Souhaitez-vous vraiment ${statut ? "activer" : "désactiver"} cette inscription ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: statut
            ? "Activation en cours..."
            : "Désactivation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await updateStudentRegistration(archiveItem.id, {
            id_class: archiveItem.id_class,
            statut: statut,
          });
          MySwal.fire({
            title:
              "Inscription " +
              (statut ? "activée" : "désactivée") +
              " avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          fetchStudentArchive();
          // reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.message ||
              err.response?.data?.message ||
              err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // Traitement en alerte de la suppression d'une inscription
  const showConfirmationAlertRegistration = (registration: any) => {
    MySwal.fire({
      title: "Supprimer une incription ?",
      text: `Souhaitez-vous vraiment supprimer cette inscription ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          //On lance la requête d'envoi de mail
          await deteleStudentRegistration(
            registration?.AcademicYear?.id,
            registration?.StudentProfil?.id,
          );
          MySwal.fire({
            title: "Inscription supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          fetchStudentArchive();
          fetchStudentParcours();
          // fetchStudentExternalNotes();
          // reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.message ||
              err.response?.data?.message ||
              err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // Traitement en alerte de la suppression d'un parcours
  const showConfirmationAlertParcours = (id_parcourStudent: string) => {
    MySwal.fire({
      title: "Supprimer un parcours ?",
      text: `Souhaitez-vous vraiment supprimer ce parcours ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          //On lance la requete pour supprimer le parcours
          await deleteStudentParcours(id_parcourStudent);
          MySwal.fire({
            title: "Parcours supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          // fetchStudentArchive();
          fetchStudentParcours();
          // fetchStudentExternalNotes();
          // reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.message ||
              err.response?.data?.message ||
              err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const openEditRegistrationModal = async (archiveItem: any) => {
    if (!archiveItem) return;
    setCurrentArchiveToEdit(archiveItem);

    try {
      const response = await getAllClass(
        archiveItem.id_academicYear,
        buildPermissionContext(Resource.STUDENT, Action.UPDATE),
      );
      const formattedClass = response.data
        .slice()
        .sort((a: any, b: any) => {
          const levelCompare = (a.Level?.label ?? "").localeCompare(
            b.Level?.label ?? "",
            "fr",
            { numeric: true, sensitivity: "base" },
          );
          if (levelCompare !== 0) return levelCompare;

          return (a.label ?? "").localeCompare(b.label ?? "", "fr", {
            numeric: true,
            sensitivity: "base",
          });
        })
        .map((classItem: any) => ({
          value: classItem.id,
          label: `${classItem.Level.label} - ${classItem.label}`,
        }));
      setEditRegistrationClasses(formattedClass);

      setEditRegistrationValue("classe", {
        value: archiveItem.id_class,
        label: `${archiveItem.Class?.Level.label} - ${archiveItem.Class?.label}`,
      });
      setEditRegistrationValue("statut", archiveItem.statut ?? false);
      setShowEditRegistrationModal(true);
    } catch (error: any) {
      // console.log(
      //   "erreur récupération des classes pour modification d'inscription: ",
      //   error,
      // );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produite, Réessayer plus tard",
      );
    }
  };

  const handleEditRegistrationClose = () => {
    resetEditRegistration();
    setCurrentArchiveToEdit(null);
    setEditRegistrationClasses([]);
    setShowEditRegistrationModal(false);
  };

  const onSubmitEditRegistration: SubmitHandler<
    editRegistrationFormFields
  > = async (data) => {
    try {
      if (!currentArchiveToEdit)
        throw new Error("Aucune inscription sélectionnée");
      await updateStudentRegistration(currentArchiveToEdit.id, {
        id_class: data.classe?.value,
        statut: data.statut,
      });
      toast.success("Modification de l'inscription réussie");
      handleEditRegistrationClose();
      fetchStudentArchive();
    } catch (error: any) {
      // console.log("erreur modification d'inscription:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produite, Réessayer plus tard",
      );
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const yearSelectorRef = useRef(null);

  const { selectedYear } = useAcademicYear();

  const [academicYears, setAcademicYears] = useState<any[]>([]);

  const [studentArchive, setStudentArchive] = useState<any[]>([]);

  const [allPromotionClass, setAllPromotionClass] = useState<any>([]);

  const [studentExternalNotes, setStudentExternalNotes] = useState<any[]>([]);

  const [studentParcours, setStudentParcours] = useState<any[]>([]);

  const [selectedParcours, setSelectedParcours] = useState<any>();
  const [showEditRegistrationModal, setShowEditRegistrationModal] =
    useState(false);
  const [currentArchiveToEdit, setCurrentArchiveToEdit] = useState<any>(null);
  const [editRegistrationClasses, setEditRegistrationClasses] = useState<any[]>(
    [],
  );

  // iniatialisation de zod avec  react-hook-form pour la gestion du formulaire
  const {
    handleSubmit,
    setValue,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm<reRegistrationFormFields>({
    resolver: zodResolver(re_registrationShema),
  });

  const {
    handleSubmit: handleSubmitEditRegistration,
    setValue: setEditRegistrationValue,
    watch: editRegistrationWatch,
    reset: resetEditRegistration,
    clearErrors: clearEditRegistrationErrors,
    formState: { errors: editRegistrationErrors },
  } = useForm<editRegistrationFormFields>({
    resolver: zodResolver(editRegistrationShema),
  });

  const promotionYear = watch("promotionYear") as {
    value: string;
    label: string;
    statut: boolean;
  } | null;
  const promotionClass = watch("promotionClass") as {
    value: string;
    label: string;
  } | null;

  // on récupère les datas des archives de létudiant
  const fetchStudentArchive = async () => {
    try {
      if (!id) throw new Error("L'id n'as pas pu être récupéré dans l'URL");
      const response = await getStudentArchivesById(id);
      // console.log("student archive: ", response.data);
      setStudentArchive(response.data);
    } catch (error: any) {
      // console.log(error);
      // Si erreur (Toast Error)
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const fetchStudentExternalNotes = async () => {
    try {
      const response = await getExternalNoteByStudent(
        id,
        buildPermissionContext(Resource.STUDENT, Action.READ),
      );
      // console.log("student external notes: ", response.data);
      setStudentExternalNotes(response.data?.notes);
    } catch (error: any) {
      // console.log(error);
      // Si erreur (Toast Error)
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // fonction pour recuperer les parcours d'un etudiant
  const fetchStudentParcours = async () => {
    try {
      const res = await getStudentParcours(
        id,
        buildPermissionContext(Resource.STUDENT, Action.READ),
      );
      // console.log("response parcours: ", res);
      setStudentParcours(res.data.ParcoursStudents ?? []);
    } catch (error: any) {
      // console.log("Erreur lors de la recuperation des parcours: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchStudentExternalNotes();
    fetchStudentParcours();
    fetchStudentArchive();
  }, []);

  // on récupère les années academique
  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await getAllAcademicYear();
        const formattedYears = response.data.map((yearItem: any) => ({
          created_at: yearItem.createdAt,
          label: yearItem.label,
          value: yearItem.id,
          statut: yearItem.statut,
        }));
        setAcademicYears(formattedYears);
      } catch (error: any) {
        // console.log("erreur récupération years: ", error);
        toast.error(
          error.message ||
            error.response?.data?.message ||
            error.response?.data?.error ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
      }
    };
    fetchYear();
  }, [selectedYear]);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        if (!promotionYear) return;
        // console.log("All parcours: ", studentParcours);

        const response = await getAllClass(
          promotionYear.value,
          buildPermissionContext(Resource.STUDENT, Action.UPDATE),
        );
        const matchedParcours = studentParcours.find(
          (p: any) => p?.id === selectedParcours,
        );

        const filteredResponse = matchedParcours
          ? response.data.filter((c: any) =>
              matchedParcours?.Parcour?.Cycle?.TypeLevels.some(
                (l: any) => l?.id === c?.Level?.id_typeLevel,
              ),
            )
          : [];

        const formattedClass = filteredResponse
          .slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Level.label
            const levelCompare = a.Level.label.localeCompare(
              b.Level.label,
              "fr",
              { numeric: true },
            );
            if (levelCompare !== 0) return levelCompare;

            // Si même Level, tri par class label
            return a.label.localeCompare(b.label, "fr", { numeric: true });
          })
          .map((classItem: any) => ({
            value: classItem.id,
            label: `${classItem.Level.label} - ${classItem.label}`,
          }));

        setAllPromotionClass(formattedClass);
        const selectedClassIsValid = formattedClass.some(
          (classe: any) => classe.value === promotionClass?.value,
        );

        if (!selectedClassIsValid) {
          setValue("promotionClass", formattedClass[0] ?? null);
        }
      } catch (error: any) {
        // console.log("erreur get class: ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
      }
    };
    fetchClassData();
  }, [promotionYear, selectedParcours, studentParcours]);

  // Fonction pour gérer la sélection des années
  const handleYearChange = (
    selectedId: string,
    option?:
      | {
          id: string;
          value: string;
          label: string;
          statut: boolean;
        }
      | {
          id: string;
          value: string;
          label: string;
          statut: boolean;
        }[]
      | undefined,
  ) => {
    // If option is an array (multi-select), pick the first item or handle as needed
    if (Array.isArray(option)) {
      if (option[0]) {
        // Remove 'id' property if present
        const { value, label, statut } = option[0];
        setValue("promotionYear", { value, label, statut });
      } else {
        setValue("promotionYear", null);
      }
    } else if (option) {
      // Remove 'id' property if present
      const { value, label, statut } = option;
      setValue("promotionYear", { value, label, statut });
    } else {
      setValue("promotionYear", null);
    }

    clearErrors();
  };

  const onSubmit: SubmitHandler<reRegistrationFormFields> = async (data) => {
    try {
      //   console.log("form data: ", data);
      if (!id) throw new Error("aucun id trouvé dans l'URL");
      const formData = {
        id_studentProfil: id,
        id_academicYear: data.promotionYear?.value,
        id_class: data.promotionClass?.value,
        id_parcoursStudent: selectedParcours,
      };
      await reRegistrationStudent(formData);
      toast.success("ré-inscription réussi avec succès");
      reset();
      fetchStudentArchive();
      setShow(false);
    } catch (error: any) {
      // console.log("erreur re-registration: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  return (
    <>
      {/* Archives et Notes externes */}
      {studentParcours.map((p: any, idx) => {
        const associatedArchive = studentArchive
          .map((arch: any) => {
            const matched_year = academicYears.find(
              (year) => arch.id_academicYear === year.value,
            );
            return {
              ...arch,
              AcademicYear: matched_year,
            };
          })
          .filter((archive: any) => archive.id_parcoursStudent === p.id);

        const associatedExternalNote = studentExternalNotes
          .map((note: any) => {
            const matched_year = academicYears.find(
              (year) => note.id_academicYear === year.value,
            );
            return {
              ...note,
              AcademicYear: matched_year,
            };
          })
          .filter((note: any) => note.id_parcoursStudent === p.id);

        const allAssociatedItem = associatedArchive
          .concat(associatedExternalNote)
          .sort(
            (a: any, b: any) =>
              new Date(a?.AcademicYear?.created_at).getTime() -
              new Date(b?.AcademicYear?.created_at).getTime(),
          );
        const min =
          allAssociatedItem[0]?.AcademicYear?.label?.split("-")[0] ?? null;
        const max =
          allAssociatedItem[
            allAssociatedItem?.length - 1
          ]?.AcademicYear?.label?.split("-")[1] ?? null;

        const isCompleted =
          p.Parcour?.Cycle?.TypeLevels?.every((level: any) =>
            allAssociatedItem.some(
              (item) =>
                (level?.id === item.Class?.Level?.id_typeLevel &&
                  item?.statut === true) ||
                level?.id === item?.Level?.id_typeLevel,
            ),
          ) ?? false;

        const misunderstood =
          allAssociatedItem.filter(
            (item: any) => item?.statut === true || item?.university,
          ).length !== p.Parcour?.Cycle?.duration;

        return (
          <div
            className="accordion mb-2 border rounded-2"
            id="accordionExample"
          >
            <div className="accordion-item">
              <h2
                className="accordion-header d-flex align-items-center"
                id="headingOne"
              >
                <button
                  className="accordion-button pt-3 pb-3 text-dark flex-grow-1 bg-transparent"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${idx}`}
                >
                  <span>
                    Parcours {`${p.Parcour.Cycle.label} ${p.Parcour.title}`} (
                    {`${min?? ""} - ${max?? ""}`})
                  </span>
                </button>

                {/* Badge + menu */}
                <div className="d-flex align-items-center gap-2 me-3">
                  {/* Badge FIXE */}
                  <span
                    className={`fs-12 badge badge-${
                      isCompleted
                        ? misunderstood
                          ? "warning"
                          : "success"
                        : "danger"
                    }`}
                    style={{ minWidth: "100px", textAlign: "center" }}
                  >
                    {isCompleted
                      ? misunderstood
                        ? "Incompris"
                        : "Complet"
                      : "Incomplet"}
                  </span>

                  {/* Dropdown actions */}
                  <div className="dropdown">
                    <button
                      className="btn btn-sm btn-light"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-dots-vertical" />
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end p-2">
                      <li>
                        <ProtectedUpdateStudent
                          setShow={setShow}
                          setSelectedParcours={setSelectedParcours}
                          id_parcourStudent={p.id}
                        />
                      </li>

                      <li>
                        <ProtectedAddExternalNote
                          setShow={setShowCreateModal}
                          setSelectedParcours={setSelectedParcours}
                          id_parcourStudent={p.id}
                        />
                      </li>

                      {allAssociatedItem.length <= 0 && (
                        <li>
                          <ProtectedButtonDeleteParcours
                            showConfirmationAlertParcours={
                              showConfirmationAlertParcours
                            }
                            id_parcourStudent={p.id}
                          />
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </h2>
              <div
                id={`collapse-${idx}`}
                className="accordion-collapse collapse "
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  {[...academicYears]
                    .sort(
                      (a: any, b: any) =>
                        new Date(b.created_at).getTime() -
                        new Date(a.created_at).getTime(),
                    )
                    .map((year: any) => {
                      // Cherche une archive pour cette année
                      const archiveItem = studentArchive.find(
                        (archive: any) =>
                          archive.id_academicYear === year.value,
                      );

                      // Cherche une note externe pour cette année
                      const externalNoteItem = studentExternalNotes.find(
                        (note: any) => note.id_academicYear === year.value,
                      );

                      // verifier si cette archive ou note externe est associer a ce parcours
                      const isAssocited =
                        archiveItem?.id_parcoursStudent === p.id ||
                        externalNoteItem?.id_parcoursStudent === p.id;

                      // Si aucune association, ne rien afficher
                      if (!isAssocited) return null;

                      return (
                        <div
                          className="d-flex justify-content-between align-items-start flex-wrap border mb-2 p-3 rounded bg-light-300"
                          key={year.value}
                        >
                          {/* Année académique */}
                          <div
                            className="text-center flex-shrink-0 me-3 mb-2"
                            style={{ minWidth: "100px" }}
                          >
                            <span className="border rounded p-2 d-inline-block">
                              {year.label}
                            </span>
                          </div>

                          {/* Si archive, affiche ses infos */}
                          {archiveItem && (
                            <>
                              {/* Statut année académique */}
                              <div
                                className="flex-shrink-0 mb-2 me-3"
                                style={{ minWidth: "100px" }}
                              >
                                <span
                                  className={
                                    "badge badge-" +
                                    (year.statut ? "success" : "danger") +
                                    " d-inline-flex align-items-center"
                                  }
                                >
                                  <i className="ti ti-circle-filled fs-5 me-1" />
                                  {`Année ${year.statut ? "Active" : "Inactive"}`}
                                </span>
                              </div>

                              {/* Statut de l'inscription */}
                              <div
                                className="flex-shrink-0 mb-2 me-3"
                                style={{ minWidth: "100px" }}
                              >
                                <span
                                  className={
                                    "badge badge-soft-" +
                                    (archiveItem.statut
                                      ? "success"
                                      : "danger") +
                                    " d-inline-flex align-items-center"
                                  }
                                >
                                  <i className="ti ti-circle-filled fs-5 me-1" />
                                  {`Inscription ${
                                    archiveItem.statut ? "Active" : "Inactive"
                                  }`}
                                </span>
                              </div>
                              {/* Classe */}
                              <div className="flex-grow-1 mb-2">
                                <h6 className="mb-0">
                                  {archiveItem?.Class?.Level.label}
                                </h6>
                                <p className="mb-0">
                                  {archiveItem?.Class?.label}
                                </p>
                              </div>
                              <div className="flex-shrink-0 mb-2">
                                <div className="d-flex align-items-center">
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      onClick={(event) =>
                                        event.preventDefault()
                                      }
                                    >
                                      <i className="ti ti-dots-vertical fs-14" />
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-right p-3">
                                      <ProtectedBtnEditRegistration
                                        openEditRegistration={
                                          openEditRegistrationModal
                                        }
                                        record={archiveItem}
                                      />
                                      <ProtectedBtnEditParcoursOfRegistration 
                                        setCurrentArchiveToEdit={setCurrentArchiveToEdit}
                                        setShowEditParcoursModal={setShowEditParcoursModal}
                                        record={archiveItem}
                                      />
                                      <ProtectedBtnDeleteRegistration
                                        showConfirmationAlertRegistration={
                                          showConfirmationAlertRegistration
                                        }
                                        record={archiveItem}
                                      />
                                      {archiveItem.statut ? (
                                        <ProtectedBtnDeactivateArchive
                                          showConfirmationAlertArchive={
                                            showConfirmationAlertArchive
                                          }
                                          record={archiveItem}
                                        />
                                      ) : (
                                        <ProtectedBtnActivateArchive
                                          showConfirmationAlertArchive={
                                            showConfirmationAlertArchive
                                          }
                                          record={archiveItem}
                                        />
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {/* Si note externe, affiche ses infos */}
                          {externalNoteItem && (
                            <>
                              {/* Badge note externe */}
                              <div
                                className="flex-shrink-0 mb-2 me-3"
                                style={{ minWidth: "100px" }}
                              >
                                <span
                                  className={
                                    "badge badge-soft-info d-inline-flex align-items-center"
                                  }
                                >
                                  <i className="ti ti-circle-filled fs-5 me-1" />
                                  Note Externe
                                </span>
                              </div>
                              <div className="flex-grow-1 mb-2">
                                <div className="d-flex align-items-center">
                                  <div className="ms-2">
                                    <p className="text-dark mb-0">
                                      <Link
                                        to={"#"}
                                      >{`${externalNoteItem?.university} - ${externalNoteItem?.Level?.label}`}</Link>
                                    </p>
                                    <span className="fs-12">
                                      {externalNoteItem?.matricule} -{" "}
                                      {externalNoteItem?.classe}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              {/* Ajoutez d'autres infos de la note externe si besoin */}
                              <div className="flex-grow-1 mb-2">
                                <div>
                                  <span style={{ fontWeight: "bold" }}>
                                    {Number(externalNoteItem?.average).toFixed(
                                      2,
                                    ) ?? "Non noté"}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "1em",
                                      color: "#666",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    (
                                    {getMention(
                                      Number(externalNoteItem?.average) ?? -1,
                                    )}
                                    )
                                  </span>
                                </div>
                              </div>
                              <div className="flex-shrink-0 mb-2">
                                <div className="d-flex align-items-center">
                                  <div className="dropdown">
                                    <Link
                                      to="#"
                                      className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      onClick={(event) =>
                                        event.preventDefault()
                                      }
                                    >
                                      <i className="ti ti-dots-vertical fs-14" />
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-right p-3">
                                      {/* preuve de la note externe */}
                                      <ProtectedPreuveExternalNote
                                        externalNoteItem={externalNoteItem}
                                        setExternalID={setExternalID}
                                        setShowModal={setShowModal}
                                      />
                                      {/* modifier note externe */}
                                      <ProtectedBtnUpdateExternalNote
                                        setEditNote={setEditNote}
                                        record={externalNoteItem}
                                        setShowEdit={setShowEditModal}
                                        id_parcourStudent={p.id}
                                        setSelectedParcours={
                                          setSelectedParcours
                                        }
                                      />
                                      {/* supprimer note externe */}
                                      <ProtectedBtnDeleteExternalNote
                                        showConfirmationAlert={
                                          showConfirmationAlert
                                        }
                                        record={externalNoteItem}
                                      />
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {/* ré-incription */}
      <ProtectedBtnAddReregistrationWithParcours
        setShowReregistrationWithParcours={setShowReregistrationWithParcours}
      />
      {/* /Archives */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="sm"
        id="add-parent-for-student"
      >
        <div className="modal-header">
          <h4 className="modal-title">Ajouter une inscription</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body pb-0">
          {/* Selection des années */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              ref={yearSelectorRef}
              className="mb-12 flex-fill "
              id="year-selector"
            >
              <label htmlFor="" className="form-label">
                Selectionné une Année universitaire
              </label>
              <br />
              <Select
                id="year-selector"
                // mode="multiple"
                //   allowClear
                className={`select ${errors.promotionYear ? "is-invalid" : ""}`}
                getPopupContainer={() =>
                  yearSelectorRef.current || document.body
                }
                style={{
                  maxWidth: "500px",
                  width: "100%",
                  color: "white",
                }}
                placeholder="Please select"
                defaultValue={"Select"}
                value={promotionYear?.value ?? undefined}
                options={
                  academicYears
                    ? academicYears.filter(
                        (y) =>
                          !studentArchive.some(
                            (archiveItem: any) =>
                              archiveItem.id_academicYear === y.value,
                            // &&archiveItem.id_parcoursStudent === selectedParcours,
                          ) &&
                          !studentExternalNotes.some(
                            (note: any) => note.id_academicYear === y.value,
                            // && note.id_parcoursStudent === selectedParcours,
                          ),
                      )
                    : academicYears
                }
                onChange={handleYearChange}
                // Permet de chercher par label a lieu de l'id
                filterOption={(input: any, option: any) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
              {errors.promotionYear && (
                <div className="invalid-feedback">
                  {errors.promotionYear?.message}
                </div>
              )}
              {promotionYear && (
                <div className="mt-2">
                  <h6>Sélectionné une classe:</h6>
                  <div className=" justify-content-between align-items-center">
                    {/* <span>Licence 01 MOP</span> */}
                    <CommonSelect
                      className={`select ${
                        errors.promotionClass ? "is-invalid" : ""
                      }`}
                      options={allPromotionClass}
                      defaultValue={undefined}
                      value={promotionClass ?? undefined}
                      onChange={(option: any) => {
                        if (option) setValue("promotionClass", option);
                        else setValue("promotionClass", null);
                        clearErrors("promotionClass");
                      }}
                    />
                    {errors.promotionClass && (
                      <div className="invalid-feedback">
                        {errors.promotionClass?.message}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="mt-4 mb-3 d-flex justify-content-end mr-8">
                <Link
                  to="#"
                  id="cancel-btn"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setValue("promotionClass", null);
                    setValue("promotionYear", null);
                    setShow(false);
                  }}
                >
                  Annuler
                </Link>
                <button type="submit" className="btn btn-primary ">
                  Valider
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        show={showEditRegistrationModal}
        onHide={handleEditRegistrationClose}
        centered
        size="sm"
        id="edit-registration-modal"
      >
        <div className="modal-header">
          <h4 className="modal-title">Modifier l'inscription</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleEditRegistrationClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body pb-0">
          <form
            onSubmit={handleSubmitEditRegistration(onSubmitEditRegistration)}
          >
            <div className="mb-12 flex-fill">
              <div className="mb-3">
                <label className="form-label">Année universitaire</label>
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={
                    academicYears.find(
                      (year: any) =>
                        year.value === currentArchiveToEdit?.id_academicYear,
                    )?.label || ""
                  }
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Classe</label>
                <CommonSelect
                  className={`select ${
                    editRegistrationErrors.classe ? "is-invalid" : ""
                  }`}
                  options={editRegistrationClasses}
                  value={editRegistrationWatch("classe") ?? undefined}
                  onChange={(option: any) => {
                    if (option) {
                      setEditRegistrationValue("classe", option);
                      clearEditRegistrationErrors("classe");
                    } else {
                      setEditRegistrationValue("classe", null);
                    }
                  }}
                />
                {editRegistrationErrors.classe && (
                  <div className="invalid-feedback">
                    {editRegistrationErrors.classe.message}
                  </div>
                )}
              </div>
              <div className="mt-4 mb-3 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  onClick={handleEditRegistrationClose}
                >
                  Annuler
                </button>
                <button type="submit" className="btn btn-primary">
                  Enregistrer
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <ReregistrationWihtNewParcours
        show={showReregistrationWithParcours}
        metaData={{
          id_studentProfil: id,
          studentArchive,
          studentExternalNotes,
          academicYears,
        }}
        onSaved={() => {
          fetchStudentArchive();
          fetchStudentParcours();
          // fetchStudentExternalNotes();
          // Refresh the data or perform any other action
        }}
        onClose={() => setShowReregistrationWithParcours(false)}
      />

      <EditParcoursModal
        show={showEditParcoursModal}
        onClose={() => {
          setShowEditParcoursModal(false);
          setCurrentArchiveToEdit(null);
        }}
        registration={currentArchiveToEdit}
        studentParcours={studentParcours}
        onSaved={() => {
          fetchStudentArchive();
          fetchStudentParcours();
        }}
      />

      <CreateExternalNoteModal
        show={showCreateModal}
        metaData={{
          id_studentProfil: id,
          studentArchive: studentArchive,
          externalNotes: studentExternalNotes,
          id_parcourStudent: selectedParcours,
        }}
        onClose={() => setShowCreateModal(false)}
        onSaved={() => {
          fetchStudentExternalNotes();

          // Refresh the data or perform any other action
        }}
      />
      <EditExternalNoteModal
        show={showEditModal}
        studentArchive={studentArchive}
        externalNotes={studentExternalNotes}
        externalNoteID={editNote}
        id_parcoursStudent={selectedParcours}
        onClose={() => setShowEditModal(false)}
        onSaved={() => {
          fetchStudentExternalNotes();
        }}
      />

      <ExternalModalApercu
        show={showModal}
        metaData={{
          externalID,
          academicYear: selectedYear?.label,
        }}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default StudentArchive;
